import { request as __request } from "../core/request.js";
export class ZarzDzaniePaczkamiService {
    /**
     * Get Complete Parcel List
     * Metoda do pobrania kompletnej listy paczek obsługiwanych w systemie. Całkowita liczba paczek w systemie wynosi 5 i tyle paczek będzie zawsze wracane w ramach usługi od samego początku uruchomienia (Na starcie zakładamy 5 paczek ze statusem ODEBRANE). Każda paczka z jednym z unikalnych identyfikatorów wskazanych w polu id.
     * @returns any Operacja zakończyła się powodzeniem.
     * @throws ApiError
     */
    static async getParcelList() {
        const result = await __request({
            method: 'GET',
            path: `/api/apm/parcels`,
            errors: {
                404: `Nie znaleziono zasobu.`,
                500: `Wystąpił nieoczekiwany błąd po stronie serwera usługi.`,
            },
        });
        return result.body;
    }
    /**
     * Clear parcels
     * Metoda awaryjna do zakończenia procesów wszystkich paczek z systemu w sytuacji gdy doszło do komplikacji. Metoda umożliwia ustawienie statusu ODEBRANA(RECEIVED) na wszystkich paczkach w ramach jednej operacji.  Dodatkowo otwarte zostają wszystkie drzwiczki skrytek, w których znajdowały się paczki
     * @returns BaseResponse Serwer przyjął żądanie, operacja zakończona powodzeniem
     * @throws ApiError
     */
    static async deleteParcels() {
        const result = await __request({
            method: 'DELETE',
            path: `/api/apm/parcels`,
            errors: {
                400: `Serwer nie mógł zrozumieć żądania z powodu niepoprawnej składni.`,
                404: `Nie znaleziono zasobu.`,
                500: `Wystąpił nieoczekiwany błąd po stronie serwera usługi.`,
            },
        });
        return result.body;
    }
    /**
     * Update parcel
     * Metoda do aktualizacji paczki w systemie, a w szczególności jej statusu. Początkowym statusem w systemie jest paczka odebrana (RECEIVED). W przypadku przejścia na status READY_TO_SEND paczka zostaje nadana, a więc do aktualizacji są odpowiadające znaczniki czasowe oraz aplikacja lokalna przypisuje skrytke do której ma  zostać zdeponowana paczka. Przejście na status TRANSPORT, aplikacja lokalna jest zobligowana przypisać nowy id skrytki aby zasymulować transport w ramach paczkomatu. W pozostałych zmianach stanu wystarczy zaktualizowanie czasu.
     * @returns FullParcel Operacja zakończyła się powodzeniem.
     * @throws ApiError
     */
    static async updateParcel({ id, requestBody, }) {
        const result = await __request({
            method: 'PUT',
            path: `/api/apm/parcels/${id}`,
            body: requestBody,
            errors: {
                400: `Serwer nie mógł zrozumieć żądania z powodu niepoprawnej składni.`,
                404: `Nie znaleziono zasobu.`,
                500: `Wystąpił nieoczekiwany błąd po stronie serwera usługi.`,
            },
        });
        return result.body;
    }
}
//# sourceMappingURL=ZarzDzaniePaczkamiService.js.map